import { LegacyLinkButton, LinkButton } from '@common';
import { Box } from '@mantine/core';
import { ScheduleEventData } from '@mantine/schedule';
import type { PayloadType } from '../../../../types';

type ScheduleEventPropsType = {
  event: ScheduleEventData<PayloadType>;
} & React.ComponentPropsWithoutRef<'button'> & {
    children: React.ReactNode;
  };

export const EventButton: React.FC<ScheduleEventPropsType> = ({
  event,
  ...props
}) => {
  const getEventButton = () => {
    switch (event.payload?.type) {
      case 'BDAY':
        return (
          <LinkButton
            to="/persons/$id"
            params={{ id: event.payload?.birthday?.person.id ?? '' }}
            {...props}
          />
        );
      case 'SHOW':
        return (
          <LegacyLinkButton
            href={`/projects/touring/${event.payload?.show?.show.tour.id ?? ''}`}
            {...props}
          />
        );
      case 'FESTIVAL':
        return (
          <LegacyLinkButton
            href={`/projects/festivals/${event.payload?.festival?.festival.id ?? ''}`}
            {...props}
          />
        );
      case 'ANNOUNCEMENT':
        return (
          <LegacyLinkButton
            href={`/projects/touring/${event.payload?.announcement?.tour.id ?? ''}`}
            {...props}
            style={{
              ...props.style,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 4,
              fontSize: 12,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              pointerEvents: 'all',
              cursor: 'pointer',
              paddingInline: 2,
            }}
          >
            <Box
              component="span"
              style={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: `var(--event-bg)`,
                flexShrink: 0,
              }}
            />
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {event.title}
            </span>
          </LegacyLinkButton>
        );
      default:
        return <div></div>;
    }
  };

  return getEventButton();
};
